import React from 'react';
import { Instagram } from 'lucide-react';

const inputClass =
  'px-4 py-3 bg-black/50 border border-silver-900/50 rounded-lg text-white placeholder:text-white/40 focus:outline-none focus:border-silver-400 transition-colors';

const ContactInfo = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-silver-400/10 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-silver-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <div>
                <h4 className="text-white font-semibold mb-2">Website</h4>
                <a
                  href="https://www.RhodiumRecords.music"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-silver-400 hover:text-silver-300 transition-colors"
                >
                  www.RhodiumRecords.music
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-silver-400/10 flex items-center justify-center flex-shrink-0">
                <svg className="w-5 h-5 text-silver-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <h4 className="text-white font-semibold mb-2">Contact & Demo Submissions</h4>
                <a href="mailto:info@rhodiumrecords.music" className="text-silver-400 hover:text-silver-300 transition-colors">
                  info@rhodiumrecords.music
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 md:col-span-2">
              <div className="w-12 h-12 rounded-full bg-silver-400/10 flex items-center justify-center flex-shrink-0">
                <Instagram size={20} className="text-silver-400" />
              </div>
              <div>
                <h4 className="text-white font-semibold mb-2">Follow Us</h4>
                <a
                  href="https://www.instagram.com/rhodiumrecordsmusic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-silver-400 hover:text-silver-300 transition-colors"
                >
                  @RhodiumRecordsMusic
                </a>
              </div>
            </div>
  </div>
);

const ContactForm = () => (
  <div className="mt-12 pt-8 border-t border-silver-900/30">
    <h4 className="text-white font-semibold mb-6 text-center">Send Us a Message</h4>
    <form className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input type="text" placeholder="Your Name" className={inputClass} />
        <input type="email" placeholder="Your Email" className={inputClass} />
      </div>
      <input type="text" placeholder="Subject" className={`w-full ${inputClass}`} />
      <textarea placeholder="Your Message" rows="5" className={`w-full resize-none ${inputClass}`} />
      <button
        type="submit"
        className="w-full px-6 py-4 bg-silver-400 hover:bg-silver-300 text-black font-bold text-sm uppercase tracking-wider rounded-lg transition-all duration-300 hover:scale-105"
      >
        Send Message
      </button>
    </form>
  </div>
);

export const ContactSection = () => (
  <section className="py-20 px-6" data-testid="contact-section">
    <div className="container mx-auto">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-silver-900/20 to-silver-900/5 border border-silver-400/20 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center">
            Get In <span className="text-silver-400">Touch</span>
          </h3>
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </div>
  </section>
);
